// extracted by mini-css-extract-plugin
module.exports = {"passwordIcon":"Form_passwordIcon__3pQnG","keepMeSigned":"Form_keepMeSigned__x7w0s","signInBtn":"Form_signInBtn__3c7XO"};